<template>
<div>

<div class="nekretnineFeed">
  
    <div class="center">
     
     <div class="nekretnine">
        <div class="sortBy">
        <h3>Pretražite nekretnine</h3>
        <div class="hidden-md-and-down">
        <label for="sortBy">Sortiraj:</label><br>
        <select name="sortBy" @change="search()" v-model="data.sort" class="sortSelect" id="">
          <option selected value="Najnovije">Najnovije</option>
          <option value="Najstarije">Najstarije</option>
          <option value="Najjeftinije">Najjeftinije</option>
          <option value="Najskuplje">Najskuplje</option>
        </select>
        </div>
        </div>
        <div class="filteriFild 
         hidden-lg-and-up"
         @click="activeFilters = !activeFilters"
         >Filteri</div>
        <div class="mobileSeach 
          hidden-lg-and-up"
         :class="{activeFilters: activeFilters}"
          >
          <div class="select">
            <label for="purpose">Namjena:</label>
            <select v-model="data.purpose" name="purpose">
              <option default selected value="">Izaberite</option>
              <option value="Prodaja">Prodaja</option>
              <option value="Izdavanje">Izdavanje</option>
              <option value="Stan na dan">Stan na dan</option>
            </select>
          </div>
          <div class="select">
              <label for="town">Grad:</label>
            <select v-model="data.town" name="town">
              <option default selected value="">Izaberite</option>

              <option value="Andrijevica">Andrijevica</option>
              <option value="Bar">Bar</option>
              <option value="Berane">Berane</option>
              <option value="Bijelo Polje">Bijelo Polje</option>
              <option value="Budva">Budva</option>
              <option value="Cetinje">Cetinje</option>
              <option value="Danilovgrad">Danilovgrad</option>
              <option value="Gusinje">Gusinje</option>
              <option value="Herceg Novi">Herceg Novi</option>
              <option value="Kolasin">Kolašin</option>
              <option value="Kotor">Kotor</option>
              <option value="Mojkovac">Mojkovac</option>
              <option value="Niksic">Nikšić</option>
              <option value="Petnjica">Petnjica</option>
              <option value="Plav">Plav</option>
              <option value="Pluzine">Plužine</option>
              <option value="Pljevlja">Pljevlja</option>
              <option value="Podgorica">Podgorica</option>
              <option value="Rozaje">Rožaje</option>
              <option value="Savnik">Šavnik</option>
              <option value="Tivat">Tivat</option>
              <option value="Tuzi">Tuzi</option>
              <option value="Ulcinj">Ulcinj</option>
              <option value="Zabljak">Žabljak</option>
            </select>
          </div>
          <div class="select" v-if="data.town === 'Podgorica'">
              <label for="settlement">Naselje:</label>
            <select v-model="data.settlement" name="settlement">
              <option default selected value="">Izaberite</option>
              <option value="1 maj">1 maj</option>
              <option value="Autobuska stanica">Autobuska stanica</option>
              <option value="Barutana">Barutana</option>
              <option value="Baston">Baston</option>
              <option value="Beri">Beri</option>
              <option value="Bioče">Bioče</option>
              <option value="Blok 5">Blok 5</option>
              <option value="Blok 6">Blok 6</option>
              <option value="Blok 7">Blok 7</option>
              <option value="Blok 9">Blok 9</option>
              <option value="Botun">Botun</option>
              <option value="Brežine">Brežine</option>
              <option value="Centar">Centar</option>
              <option value="Central Point">Central Point</option>
              <option value="Cijevna">Cijevna</option>
              <option value="City Kej">City Kej</option>
              <option value="City Kvart">City Kvart</option>
              <option value="Crnci">Crnci</option>
              <option value="Cvijetin Brijeg">Cvijetin Brijeg</option>
              <option value="Dahna">Dahna</option>
              <option value="Dajbabe">Dajbabe</option>
              <option value="Dalmatinska ulica">Dalmatinska ulica</option>
              <option value="Doljani">Doljani</option>
              <option value="Donja Gorica">Donja Gorica</option>
              <option value="Donji Kokoti">Donji Kokoti</option>
              <option value="Drač">Drač</option>
              <option value="Farmaci">Farmaci</option>
              <option value="Gintaš">Gintaš</option>
              <option value="Golubovci">Golubovci</option>
              <option value="Gorica C">Gorica C</option>
              <option value="Gornja Gorica">Gornja Gorica</option>
              <option value="Gornji Kokoti">Gornji Kokoti</option>
              <option value="Ibričevina">Ibričevina</option>
              <option value="Kakaricka Gora">Kakaricka Gora</option>
              <option value="Karabursko Polje">Karabursko Polje</option>
              <option value="Kod Big Fashion-a">Kod Big Fashion-a</option>
              <option value="Kod Capital Plaze">Kod Capital Plaze</option>
              <option value="Kokoti">Kokoti</option>
              <option value="Komani">Komani</option>
              <option value="Konik">Konik</option>
              <option value="Krivi Most">Krivi Most</option>
              <option value="Kruševac">Kruševac</option>
              <option value="Kuče">Kuče</option>
              <option value="Kuči">Kuči</option>
              <option value="Kuće Rakića">Kuće Rakića</option>
              <option value="Lepa Kata">Lepa Kata</option>
              <option value="Lješanska Nahija">Lješanska Nahija</option>
              <option value="Ljubović">Ljubović</option>
              <option value="Malo Brdo">Malo Brdo</option>
              <option value="Mareza">Mareza</option>
              <option value="Master Kvart">Master Kvart</option>
              <option value="Masline">Masline</option>
              <option value="Mataguži">Mataguži</option>
              <option value="Momišići">Momišići</option>
              <option value="Murtovina">Murtovina</option>
              <option value="New City">New City</option>
              <option value="Nova Dalmatinska">Nova Dalmatinska</option>
              <option value="Obala Morače">Obala Morače</option>
              <option value="Pejton">Pejton</option>
              <option value="Piperi">Piperi</option>
              <option value="Pod Goricom">Pod Goricom</option>
              <option value="Pobrežje">Pobrežje</option>
              <option value="Preko Morače">Preko Morače</option>
              <option value="Pričelje">Pričelje</option>
              <option value="Radovče">Radovče</option>
              <option value="Rogami">Rogami</option>
              <option value="Sadine">Sadine</option>
              <option value="Stanjevića Rupa">Stanjevića Rupa</option>
              <option value="Stara Varoš">Stara Varoš</option>
              <option value="Stari Aerodrom">Stari Aerodrom</option>
              <option value="Tološi">Tološi</option>
              <option value="Tološka šuma">Tološka šuma</option>
              <option value="Tuški Put">Tuški Put</option>
              <option value="Velje Brdo">Velje Brdo</option>
              <option value="Veruša">Veruša</option>
              <option value="Vezirov Most">Vezirov Most</option>
              <option value="Vranići">Vranići</option>
              <option value="Vrela Ribnička">Vrela Ribnička</option>
              <option value="Zabjelo">Zabjelo</option>
              <option value="Zagorič">Zagorič</option>
              <option value="Zelenika">Zelenika</option>
              <option value="Zeta">Zeta</option>
              <option value="Zlatica">Zlatica</option>
            </select>
          </div>
          <div class="select">
              <label for="type">Vrsta:</label>
            <select  v-model="data.category" name="type">
              <option default selected value="">Izaberite</option>

              <option value="Stan">Stan</option>
              <option value="Kuca">Kuća</option>
              <option value="Zemljiste">Zemljište</option>
              <option value="Poslovni prostor">Poslovni prostor</option>
              <option value="Hotel">Hotel</option>
              <option value="Garaza">Garaža</option>
              <option value="Ugostiteljski objekat">Ugostiteljski objekat</option>
            </select>
          </div>
          <div class="select">
              <label for="status">Status:</label>
            <select v-model="data.status" name="status">
              <option default selected value="">Izaberite</option>

              <option value="Namjesteno">Namješteno</option>
              <option value="Nenamjesteno">Nenamješteno</option>
            </select>
          </div>
          <div class="select">
              <label for="structure">Struktura:</label>
            <select v-model="data.type" name="structure">
              <option default selected value="">Izaberite</option>

              <option value="Garsonjera">Garsonjera</option>
              <option value="Jednosoban">Jednosoban</option>
              <option value="Dvosoban">Dvosoban</option>
              <option value="Trosoban">Trosoban</option>
              <option value="Cetvorosoban">Četvorosoban</option>
              <option value="Petosoban">Petosoban</option>
            </select>
          </div>
            <div class="select">
              <label for="price">Cijena:</label>
             <section class="priceDrop" >

              <input  v-model="data.priceMin" style="padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Od:">
              <input  v-model="data.priceMax" style="padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Do:">
             </section>


          </div>
          <div class="select" >
             <label for="purpose">Kvadratura:</label>
              <section class="priceDrop" >

              <input v-model="data.sizeMin" style="padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Od:">
              <input v-model="data.sizeeMax" style="padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Do:">
              </section>
          </div>
          <div><div @click="search()"   class="searchBtn seachmob">Pretraži</div></div>
        </div>
        <div class="searchField hidden-md-and-down searchRow">
          <div class="select">
            <label for="purpose">Namjena:</label>
            <select  v-model="data.purpose" name="purpose">
              <option default selected value="">Izaberite</option>
              <option value="Prodaja">Prodaja</option>
              <option value="Izdavanje">Izdavanje</option>
              <option value="Stan na dan">Stan na dan</option>
            </select>
          </div>
          <div class="select" >
              <label for="town">Grad:</label>
            <select v-model="data.town" name="town">
              <option default selected value="">Izaberite</option>

              <option value="Andrijevica">Andrijevica</option>
              <option value="Bar">Bar</option>
              <option value="Berane">Berane</option>
              <option value="Bijelo Polje">Bijelo Polje</option>
              <option value="Budva">Budva</option>
              <option value="Cetinje">Cetinje</option>
              <option value="Danilovgrad">Danilovgrad</option>
              <option value="Gusinje">Gusinje</option>
              <option value="Herceg Novi">Herceg Novi</option>
              <option value="Kolasin">Kolašin</option>
              <option value="Kotor">Kotor</option>
              <option value="Mojkovac">Mojkovac</option>
              <option value="Niksic">Nikšić</option>
              <option value="Petnjica">Petnjica</option>
              <option value="Plav">Plav</option>
              <option value="Pluzine">Plužine</option>
              <option value="Pljevlja">Pljevlja</option>
              <option value="Podgorica">Podgorica</option>
              <option value="Rozaje">Rožaje</option>
              <option value="Savnik">Šavnik</option>
              <option value="Tivat">Tivat</option>
              <option value="Tuzi">Tuzi</option>
              <option value="Ulcinj">Ulcinj</option>
              <option value="Zabljak">Žabljak</option>
            </select>
          </div>
          <div class="select" v-if="data.town === 'Podgorica'">
              <label for="settlement">Naselje:</label>
            <select v-model="data.settlement" name="settlement">
              <option default selected value="">Izaberite</option>
              <option value="1 maj">1 maj</option>
              <option value="Autobuska stanica">Autobuska stanica</option>
              <option value="Barutana">Barutana</option>
              <option value="Baston">Baston</option>
              <option value="Beri">Beri</option>
              <option value="Bioče">Bioče</option>
              <option value="Blok 5">Blok 5</option>
              <option value="Blok 6">Blok 6</option>
              <option value="Blok 7">Blok 7</option>
              <option value="Blok 9">Blok 9</option>
              <option value="Botun">Botun</option>
              <option value="Brežine">Brežine</option>
              <option value="Centar">Centar</option>
              <option value="Central Point">Central Point</option>
              <option value="Cijevna">Cijevna</option>
              <option value="City Kej">City Kej</option>
              <option value="City Kvart">City Kvart</option>
              <option value="Crnci">Crnci</option>
              <option value="Cvijetin Brijeg">Cvijetin Brijeg</option>
              <option value="Dahna">Dahna</option>
              <option value="Dajbabe">Dajbabe</option>
              <option value="Dalmatinska ulica">Dalmatinska ulica</option>
              <option value="Doljani">Doljani</option>
              <option value="Donja Gorica">Donja Gorica</option>
              <option value="Donji Kokoti">Donji Kokoti</option>
              <option value="Drač">Drač</option>
              <option value="Farmaci">Farmaci</option>
              <option value="Gintaš">Gintaš</option>
              <option value="Golubovci">Golubovci</option>
              <option value="Gorica C">Gorica C</option>
              <option value="Gornja Gorica">Gornja Gorica</option>
              <option value="Gornji Kokoti">Gornji Kokoti</option>
              <option value="Ibričevina">Ibričevina</option>
              <option value="Kakaricka Gora">Kakaricka Gora</option>
              <option value="Karabursko Polje">Karabursko Polje</option>
              <option value="Kod Big Fashion-a">Kod Big Fashion-a</option>
              <option value="Kod Capital Plaze">Kod Capital Plaze</option>
              <option value="Kokoti">Kokoti</option>
              <option value="Komani">Komani</option>
              <option value="Konik">Konik</option>
              <option value="Krivi Most">Krivi Most</option>
              <option value="Kruševac">Kruševac</option>
              <option value="Kuče">Kuče</option>
              <option value="Kuči">Kuči</option>
              <option value="Kuće Rakića">Kuće Rakića</option>
              <option value="Lepa Kata">Lepa Kata</option>
              <option value="Lješanska Nahija">Lješanska Nahija</option>
              <option value="Ljubović">Ljubović</option>
              <option value="Malo Brdo">Malo Brdo</option>
              <option value="Mareza">Mareza</option>
              <option value="Master Kvart">Master Kvart</option>
              <option value="Masline">Masline</option>
              <option value="Mataguži">Mataguži</option>
              <option value="Momišići">Momišići</option>
              <option value="Murtovina">Murtovina</option>
              <option value="New City">New City</option>
              <option value="Nova Dalmatinska">Nova Dalmatinska</option>
              <option value="Obala Morače">Obala Morače</option>
              <option value="Pejton">Pejton</option>
              <option value="Piperi">Piperi</option>
              <option value="Pod Goricom">Pod Goricom</option>
              <option value="Pobrežje">Pobrežje</option>
              <option value="Preko Morače">Preko Morače</option>
              <option value="Pričelje">Pričelje</option>
              <option value="Radovče">Radovče</option>
              <option value="Rogami">Rogami</option>
              <option value="Sadine">Sadine</option>
              <option value="Stanjevića Rupa">Stanjevića Rupa</option>
              <option value="Stara Varoš">Stara Varoš</option>
              <option value="Stari Aerodrom">Stari Aerodrom</option>
              <option value="Tološi">Tološi</option>
              <option value="Tološka šuma">Tološka šuma</option>
              <option value="Tuški Put">Tuški Put</option>
              <option value="Velje Brdo">Velje Brdo</option>
              <option value="Veruša">Veruša</option>
              <option value="Vezirov Most">Vezirov Most</option>
              <option value="Vranići">Vranići</option>
              <option value="Vrela Ribnička">Vrela Ribnička</option>
              <option value="Zabjelo">Zabjelo</option>
              <option value="Zagorič">Zagorič</option>
              <option value="Zelenika">Zelenika</option>
              <option value="Zeta">Zeta</option>
              <option value="Zlatica">Zlatica</option>
            </select>
          </div>
          <div class="select">
              <label for="type">Vrsta:</label>
            <select v-model="data.category" name="type">
              <option default selected value="">Izaberite</option>

              <option value="Stan">Stan</option>
              <option value="Kuca">Kuća</option>
              <option value="Zemljiste">Zemljište</option>
              <option value="Poslovni prostor">Poslovni prostor</option>
              <option value="Hotel">Hotel</option>
              <option value="Garaza">Garaža</option>
              <option value="Ugostiteljski objekat">Ugostiteljski objekat</option>
            </select>
          </div>
          <div class="select">
              <label for="status">Status:</label>
            <select v-model="data.status" name="status">
              <option default selected value="">Izaberite</option>

              <option value="Namjesteno">Namješteno</option>
              <option value="Nenamjesteno">Nenamješteno</option>
            </select>
          </div>
        </div>
        <div class="searchField hidden-md-and-down searchRow" style="border-top-left-radius: 0px; border-top-right-radius: 0px;">
          <div class="select">
              <label for="structure">Struktura:</label>
            <select v-model="data.type" name="structure">
              <option default selected value="">Izaberite</option>

              <option value="Garsonjera">Garsonjera</option>
              <option value="Jednosoban">Jednosoban</option>
              <option value="Dvosoban">Dvosoban</option>
              <option value="Trosoban">Trosoban</option>
              <option value="Cetvorosoban">Četvorosoban</option>
              <option value="Petosoban">Petosoban</option>
            </select>
          </div>
          <div class="select">
              <label for="price">Cijena:</label>
             <section class="priceDrop" >
              <input v-model="data.priceMin" style="width:110px;padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Od:"><span style="color:black">-</span>
              <input v-model="data.priceMax" style="width:110px;padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Do:">
             </section>
          </div>
          <div class="select" >
             <label for="purpose">Kvadratura:</label>
              <section class="priceDrop" >
              <input v-model="data.sizeMin" style="width:110px;padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Od:"><span style="color:black">-</span>
              <input v-model="data.sizeMax" style="width:110px;padding:6px;border-bottom:1px solid #919191" type="number" min="0" placeholder="Do:">
              </section>
          </div>
        </div>
        <div class="hidden-md-and-down searchBtnRow">
          <div @click="search()" class="searchBtn">Pretraži</div>
        </div>
        <div id="srcScr"></div>
          <div class="sortMobile hidden-lg-and-up" >
   <label for="sortBy" >Sortiraj:</label><br>
   <select name="sortBy" @change="search()" v-model="data.sort"  class="sortSelect" id="">
          <option selected value="Najnovije">Najnovije</option>
          <option value="Najstarije">Najstarije</option>
          <option value="Najjeftinije">Najjeftinije</option>
          <option value="Najskuplje">Najskuplje</option>
        </select>
        </div>
        <div class="progres" v-if="progress == true">
        <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
    </div>
  
     </div>
     </div>
   
   <div id="scrollTO" style="margin-bottom:20px"></div>
   <center>
      <h2 v-if="findErr" style=" margin-top: 140px;">Nema rezultata.</h2>
    </center>
    <main v-if="progress == false">
   
    <div class="cards">
      
      <div v-for="item in items" :key="item._id"   class="card">
        <router-link :to="`/nekretnine/`+item._id">
       <div class="cardImage">
        <img :src="'/'+item.images[0]" alt="nekretnina">
       </div>
       <div class="cardContent">
        <div class="hedCard">
          <div class="rent">
        <span class="price">€ {{ item.price }}</span> <br>
        </div><br>
        <!-- <div class="id">ID: 5</div> -->
        <div v-if="item.purpose == 'Prodaja'" class="category">
           Prodaja
        </div>
        <div v-if="item.purpose == 'Izdavanje'" style="background-color:black" class="category">
           Izdavanje
        </div>
        <div v-if="item.purpose == 'Stan na dan'" style="background-color:red" class="category">
          Stan na dan
        </div>
        </div>
       <h4 style="  font-weight: bold; -webkit-font-weight: bold; margin-top:7px">{{item.name}}</h4>
        <p style="color:grey" >{{item.town}}<span v-if="item.settlement">, {{item.settlement}}</span></p>

        <hr>
        <div class="cardFooter">
          <div v-if="item.roomsNum" class="bed">
            <img src="/bedFin.png" alt=""> {{ item.roomsNum + "  soba"}}
          </div>
          <div class="bed" v-if="item.bathroomsNum && Number(item.bathroomsNum) > 0">
            <img src="/bathroom.png" alt=""> {{ item.bathroomsNum + "   kupatila"}}
          </div>
          <div class="bed">
            <img src="/maximize.png" alt=""> {{ item.size + " m2" }}
          </div>
        </div>
      </div>
    </router-link>
      </div>
    
    </div>
  </main>
    <!-- <div class="paginationDiv">
    <div v-if="page == 1" class="pagination">
      <v-icon @click="changePage(page-1)" class="arrow">fa-chevron-left</v-icon>
      <div @click="changePage(page)" class="paginationNum active">{{page}}</div>
      <div @click="changePage(page+1)" class="paginationNum">{{page+1}}</div>
      <div @click="changePage(page+2)" class="paginationNum">{{page+2}}</div>
      <div class="dots">...</div>
      <div @click="changePage(lastPage)" class="paginationNum">{{lastPage}}</div>
      <v-icon @click="changePage(page+1)" class="arrow">fa-chevron-right</v-icon>

    </div>
    </div> -->

    <pagination
      :totalPages="lastPage"
      :perPage="9"
      :currentPage="page"
      @pagechanged="onPageChange"
    />
    
   



   </div>
   </div>
  
</template>
<script>
import Pagination from './PaginationCom.vue'
// import apiPost from '../../services/service'
import axios from 'axios'

export default {
  components: {
    Pagination
  },
    data () { 
      return{
        activeFilters:false,
        findErr:false,
      progress:false,
      items: [],
      data:{
        category:"",
        town:"",
        settlement:"",
        purpose:"",
        status:"",
        type:"",
        priceMin:"",
        priceMax:"",
        sizeMin:"",
        sizeMax:"",
        sort:"Najnovije",
        roomsNum:'',
        bathroomsNum:''
      },
      page:1,
      pagination:[],
      lastPage:1
      }
    },

    async mounted () {
        const query = this.$route.query
       //javascript empty object
        // function isEmpty(object) {
        //   return Object.keys(object).length === 0;
        // }
       
      try {
        // if(!isEmpty(query)) this.data = query
        if(query.category) this.data.category = await query.category
        if(query.town) this.data.town = query.town
        if(query.settlement) this.data.settlement = query.settlement
        if(query.purpose) this.data.purpose = await query.purpose
        if(query.status) this.data.status = query.status
        if(query.type) this.data.type = query.type
        if(query.priceMin) this.data.priceMin = query.priceMin
        if(query.priceMax) this.data.priceMax = query.priceMax
        if(query.sizeMin) this.data.sizeMin = query.sizeMin
        if(query.sizeMax) this.data.sizeMax = query.sizeMax
        if(query.sort) this.data.sort = query.sort
   
        // Simple GET request using axios
        //geting data

       await axios.post('/posts/get', query, {
        headers: {
            'Content-Type': 'application/json',
        }
      })
        .then(async response => {
          this.items = await response.data.posts
          this.items.forEach(item => {
            let price = item.price;
            let newP =  price.toLocaleString('de-DE', { 
                style: 'currency', 
                currencyDisplay: 'code', 
                currency: 'EUR' 
             });
            item.price = newP.slice(0,-3)
          })
          const page = await response.data.page
          this.page = parseInt(page)
          this.lastPage = await response.data.lastPage
       })
      } catch (error) {
        console.log(error.message)
      }
      if(this.items.length < 1) this.findErr = true

       
    },
    methods:{
     async onPageChange(page) {
      //loading anim
      this.progress = true
      //scroll to top
      // document.getElementById("srcScr").scrollIntoView();

      let searchData = await this.$route.query
      searchData.page = await  page
      
      //cleaning query
      this.$router.push({ path: '/nekretnine', query: {} })
      //starting new
      this.$router.push({ path: '/nekretnine', query: searchData })

      //change page variable
      this.page = page;

      //GETTING DATA INTO FORM DATA


      //geting data
      await axios.post('/posts/get', searchData, {
        headers: {
            'Content-Type': 'application/json',
        }
      }).then(response => {
        this.items = response.data.posts
        this.items.forEach(item => {
            let price = item.price;
            let newP =  price.toLocaleString('de-DE', { 
                style: 'currency', 
                currencyDisplay: 'code', 
                currency: 'EUR' 
             });
            item.price = newP.slice(0,-3)
          })
      })
     
      
      //how long action last
      setTimeout(() => {
              this.progress = false}, 1000)
    },
      async search(){
        this.findErr = false
        const Data = this.data
        // with query, resulting 
        Data.page = 1
        this.page = 1
        this.$router.push({ path: '/nekretnine', query: {} })
        this.$router.push({ path: '/nekretnine', query: Data })
        this.progress = true
        try{
        await axios.post('/posts/get', Data, {
        headers: {
            'Content-Type': 'application/json',
        }
      }).then(async response => {
          this.items = await response.data.posts
          this.items.forEach(item => {
            let price = item.price;
            let newP =  price.toLocaleString('de-DE', { 
                style: 'currency', 
                currencyDisplay: 'code', 
                currency: 'EUR' 
             });
            item.price = newP.slice(0,-3)
          })
          this.lastPage = await response.data.lastPage

          
       })
      }catch (error) {
        this.items = []
        if(this.items.length < 1) this.findErr = true
        console.log(error.message)
      }
      


       setTimeout(() => {
              this.progress = false
              if(this.items.length < 1) this.findErr = true

            
            }, 1000)
      },
      

    }
}
</script>


<style scoped>
a{
  text-decoration: none;
}
.mobileSeach .select , .mobileSeach select{
  width: 100%;
  padding-left: 0px;
}
.mobileSeach{
  border-radius: 20px;
  padding: 15px;
  transition: 0.4s ease-in-out;
  border: 1px solid rgb(212, 212, 212);
  height: 0px;
  opacity: 0;
  overflow: hidden;
}
.filteriFild{
  margin-bottom: 5px;
  width: 100%;
  padding: 20px;
  background: #e7e6f8ba;
  border: 1px solid rgba(33,111,253,255);
  border-radius: 10px;

}
.activeFilters{
  height: 760px;
  opacity: 1;
}
.progres{
  margin-top: 40px;
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(255, 255, 255);
}
.mobileSeach .select {
  margin-bottom: 20px;
}
.mobileSeach .select input,mobileSeach .searchBtn{
  width: 100%;
}
.nekretnineFeed{
 margin-top: 80px;
 padding-top: 40px;
}
@media only screen and (max-width:850px){
  .nekretnineFeed{
 margin-top: 40px;
 padding-top: 40px;
}
}
.search{
  grid-area: header;
  justify-content: center;
}
.center{
  box-sizing: border-box;
  display: flex;
  justify-content: center;

}
.nekretnine{
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: 1160px;
}
main{
  display: grid;
  grid-template-columns: 1fr repeat(12, minmax(auto,60px)) 1fr;
  grid-gap: 40px;
  padding: 60px 0px;
}
.cards{
  grid-column: 2 / span 12;
  display: grid;
  grid-template-columns:  repeat(12, minmax(auto,60px));
  grid-gap: 40px;
  
}
.card{
  grid-column-end: span 4;
  display: flex;
  flex-direction: column;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}
.card:hover{
  transform: translateY(-7px);
}
.cardImage{
  width: 100%;
  padding-top: 100%;
  overflow: hidden;
  position: relative;
}
.cardImage img{
  border-top-left-radius: 12px;
  border-top-right-radius: 6px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cardContent{
  padding: 20px 20px 20px 20px;
}
select{
  cursor: pointer;
}
.price{
  color: rgba(33,111,253,255);
  font-weight: bold; -webkit-font-weight: bold;
  font-size: 22px;
}
.location{
  font-weight: bold; -webkit-font-weight: bold;
  color: #919191;
}
.cardFooter{
  color: #919191;
  font-weight: bold; -webkit-font-weight: bold;
  display: flex;
  justify-content: space-between;
}
.cardFooter img{
  margin-right: 5px;

}
.hedCard{
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.id{
  background:rgba(33,111,253,255) ;
  pad: 5px;
  text-align: center;
  width: 50px;
  height: 30px;
  margin-right: -60px;
  padding-top: 2px;
  color: white;
}
.category{
  background:rgba(33,111,253,255) ;
  pad: 5px;
  text-align: center;
  width: 100px;
  border-radius: 4px;
  height: 30px;
  padding-top: 2px;
  color: white;
}
.rent{
  color: grey;
}
@media only screen and (max-width:1285px){
  .nekretnine{
    width: 91%;
  }
  .searchField{
    display: none;
  }
}
@media only screen and (max-width:1000px){
  
  .card{
    grid-column-end: span 6;
  }
  .nekretnine{
    width: 92%;
  }
   .searchField{
    display: none;
  }
}
@media only screen and (max-width:700px){
  main{
    grid-gap: 20px;
  }
  .card{
    grid-column-end: span 12;
  }
  .nekretnine{
    width: 90%;
  }
   .searchField{
    display: none;
  }
}
@media only screen and (max-width:500px){
  main{
    grid-template-columns:10px repeat(6, 1fr) 10px;
    grid-gap: 10px;
  }
  .nekretnine{
    width: 90%;
  }
   .searchField{
    display: none;
  }
  .cards{
    grid-column: 2 / span 6;
    grid-template-columns:repeat(6, 1fr);
    grid-gap: 20px;

  }
  .card{
    grid-column-end: span 6;
  }
}
.sortBy{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
   margin-top: 40px;
  margin-bottom: 20px;
  
}
.sortBy h3{
  font-size: 29px;
  font-weight: 700;
}

@media only screen and (max-width:1000px){
.sortBy h3{
  font-size: 24px;
  font-weight: 700;
}
}
.searchField{
  width: 100%;
  min-height: 100px;
  height: auto;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background: white;
}
.searchBtn{
  width: 200px;
  height: 42px;
  padding: 10px 6px;
  cursor: pointer;
  color: white;
  background: rgba(33,111,253,255);
  border-radius: 8px;
  text-align: center;
}
.select{
  color: grey;
  flex-direction: column;
  padding-left: 26px;
}
select , option{
  border-bottom: 1px solid rgb(178, 178, 178);
  /* border-radius: 5px; */
  width: 234px;
  padding: 6px 2px;
}
.searchRow {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-end;
  min-height: unset;
  height: auto;
  padding: 10px 0px;
}
.searchRow .select {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.searchRow .select select {
  width: 100%;
}
.searchRow .select .priceDrop {
  display: flex;
  align-items: center;
  gap: 4px;
}
.searchRow .select .priceDrop input {
  width: 100px;
  flex: 1;
}
.searchBtnRow {
  display: flex;
  justify-content: flex-end;
  padding: 0px 0px 10px 0px;
}
input{
  color: black;
}
.sortSelect{
  border: 1px solid rgb(155, 155, 155);
  padding: 1px 15px;
  width: 240px;
  height: 45px;
  background: white;
  color: grey;
  border-radius: 10px;
  
 
}
.sortMobile{
  margin-top: 20px;
}

.filters{
  width: 100%;
  background: white;
  display: flex;
  flex-direction: row;
  border: 1px solid rgb(209, 209, 209);
  border-radius: 10px;
  padding: 16px 10px 10px 10px ;
  height: 100px;
}
.filters div{
  width: 100%;
  padding-left: 30px;
  border-right: 1px solid #E0DEF7;
}
.filters select{
  font-weight: 700;
  padding: 10px;
}
.filters label{
  color: rgba(0, 22, 25, 0.7);
  padding-left: 10px;
}

.pagination{
  font-weight: 700;
  margin-top: 25px;
  display: flex;
  justify-content: center;
}
.dots{
  margin-right: 12px;
  margin-top: 18px;
}
.paginationNum{
  padding: 4px;
  width: 45px;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(255, 255, 255);
   color: rgba(0, 22, 25, 0.7);
  border-radius: 30px;
  cursor: pointer;
  margin-right: 9px;
}
.arrow{
  font-size:16px;
  cursor: pointer;
  margin: 14px;
}
.sort{
  width: 100%;
  background: rgb(255, 255, 255);
  color: grey;
  border-radius: 10px;
  padding: 8px 10px;
  margin-bottom: 25px;
}
.active{
  background-color: #000929;
  color: white;
}
.seachmob{
  width: 100%;
}
</style>